import schema from './schema'

export default {
  modelActions: {},
  modelGetters: {
    num_of_attachments() {

    },

    num_of_checklist_items() {

    },

    num_of_checklist_items_completed() {

    },
    image_url() {

    }
  },
  staticGetters: {},
  staticActions: {},
  schema:  schema
};
